<template>
  <section class="service-parts-info container-fluid" :data-brand="brand.substr(0,1).toLowerCase() + brand.substr(1)">
    <div class="service-background row">
      <div class="container">
        <div class="row">
          <div class="col-md-6">
            <div class="info-box">
              <h2>Service Department</h2>
              <p>The service staff and technicians at Auto Dealer are highly trained on all factory services for your car. Stop by and find out what our customers, their family and friends have discovered and come to depend on: for maintenance, repairs, warranty concerns on all <span>{{brandName}}</span> vehicles. Auto Dealer defines service excellence.</p>
              <p>The Auto Dealer service team look forward to making your ownership experience as enjoyable as it is meant to be.</p>
              <a class="btn service-btn" href="#">Schedule Service</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="parts-background row">
      <div class="container">
        <div class="row">
          <div class="col-md-6 col-md-offset-6">
            <div class="info-box">
              <h2>Genuine <span>{{brandName}}</span> Parts</h2>
              <p>Auto Dealer boasts an on-site parts department that will help you secure all the genuine <span>{{brandName}}</span> parts you need to complete a job on your <span>{{brandName}}</span> vehicle today! Our team members are knowledgeable on all things <span>{{brandName}}</span> and are eager to hear about the upcoming repair you plan on completing. From vehicle belts and hoses to accessories that give your vehicle a personal touch, we have your parts needs covered!</p>
              <p>If you'd like to take advantage of such parts, but don't have a wealth of mechanical knowledge, head to our <a href="#">service department</a> for assistance. We'll happily install your items so that you can get back to exploring the streets of City. Thank you for allowing Auto Dealer to assist with all your service needs!</p>
              <a class="btn service-btn" href="#">Order Parts</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      brand: this.$store.state.chosenBrand
    }
  },
  computed: {
    brandName () {
      if (this.brand === 'none') {
        return 'Brand';
      } else if (this.brand === 'infiniti' || this.brand === 'cjdr') {
        return this.brand.toUpperCase();
      } else {
        return this.brand.charAt(0).toUpperCase() + this.brand.slice(1);
      }
    }
  },
  mounted() {
  }
};
</script>

<style
  scoped
  src="../../static/bootstrap-3.3.7-dist/css/bootstrap.min.css"
></style>

<style scoped>
.service-parts-info {
  margin: 30px 0;
}
.service-parts-info .service-background {
  background-image: url(../../static/images/service-stock-img.jpeg);
  background-size: cover;
  background-position-x: 75%;
  background-attachment: fixed;
  padding: 30px 0;
  margin-bottom: 3px;
}
.service-parts-info .parts-background {
  background-image: url(../../static/images/parts-service-stock-image.jpeg);
  background-size: cover;
  background-position: center;
  background-attachment: fixed;
  padding: 30px 0;
}      
.service-parts-info .info-box {
  background: rgba(255, 255, 255, 0.8);
  color: #000;
  padding: 15px;
  font-size: 16px;
  border-radius: 8px;
}
.service-parts-info .info-box p a {
  color: var(--secondary-color);
  font-weight: 600;
  font-size: inherit !important;
  text-transform: none !important;
}
.service-parts-info .info-box p a:hover {
  text-decoration: underline !important;
}
.service-parts-info .service-btn {
  color: #fff;
  background: var(--primary-color);
  padding: 8px 40px;
  border-radius: 20px;
  font-size: 18px;
  margin: 10px auto;
  -webkit-transition: all 0.3s ease;
  -moz-transition: all 0.3s ease;
  -o-transition: all 0.3s ease;
  transition: all 0.3s ease;
  transform: perspective(1px) translateZ(0);
  -webkit-transition-duration: 0.3s;
  transition-duration: 0.3s;
  -webkit-transition-property: transform;
  transition-property: transform;
  box-shadow: 2px 13px 27px -10px #0F032C;
}
.service-parts-info[data-brand="cjdr"] .service-btn {
  background: var(--secondary-color);
}
.service-parts-info .service-btn:hover {
  text-decoration: none;
  color: #fff;
  box-shadow: 0px 5px 25px -4px #0F032C;
  transform: scale(.98);
}

@media (max-width:768px) {
  .service-parts-info .service-background, .service-parts-info .parts-background {
    padding: 15px 0;
  }
  .service-parts-info .service-btn {
    display: block;
    padding: 5px 10px;
  }
}
</style>